export const defaultTimeout = 10000 * 12;
